module.exports = __webpack_public_path__ + "img/tmh-55x60.36ed8b3e.jpg";